import { combineReducers } from "redux";

import userSlice from "./UserSlice";
import coinflipSlice from "./CoinflipSlice";
import jackpotSlice from "./jackpotSlice";
import blackjackSlice from "./blackjackSlice";
import blackjackLobbySlice from "./blackjackLobbySlice";
import walletSlice from "./WalletSlice";
import chatSlice from "./chatSlice";
import uiSlice from "./uiSlice";
import userTransactionsSlice from "./UserTransactionsSlice";

const combinedReducer = combineReducers({
  userData: userSlice.reducer,
  coinflipData: coinflipSlice.reducer,
  jackpot: jackpotSlice.reducer,
  blackjack: blackjackSlice.reducer,
  blackjackLobby: blackjackLobbySlice.reducer,
  wallet: walletSlice.reducer,
  chat: chatSlice.reducer,
  ui: uiSlice.reducer,
  userTransactions: userTransactionsSlice.reducer,
});

type RootReducerType = typeof combinedReducer;

const rootReducer: RootReducerType = (state, action) =>
  combinedReducer(state, action);

export type { RootReducerType };
export { rootReducer };
